import React from "react";
import PropTypes from "prop-types";
import { Button, Grid } from "@mui/material";
import { useGetSitesQuery } from "../../../../features/sites/sitesApiSlice";

function SelectSiteStep({ onSelect }) {
  const { data: sites } = useGetSitesQuery();

  return (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <Grid container justify="center" spacing={3}>
        {sites &&
          sites.map((standort, i) => {
            if (standort.standortType === "AFFILIATED") {
              return null;
            }
            return (
              <Grid item justify="center" key={"siteSelection-" + i} xs={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ fontSize: 25, minWidth: "220px" }}
                  onClick={() => onSelect(standort)}
                >
                  {standort.siteName}
                </Button>
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
}

SelectSiteStep.propTypes = {
  onSelect: PropTypes.func,
};

export default SelectSiteStep;
